import React from 'react';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { createModal } from 'react-style-guide';
import { ratingsTranslationConfig } from '../translation.config';
import ratingConstants from '../constants/ratingConstants';

export const Ratings = ({ translate }: WithTranslationsProps): JSX.Element => {
  const [Modal, modalService] = createModal();
  const { interactiveDescription, ratingDescription, ratingName, ratingIconUrl, ratingUrl } =
    ratingConstants.ratingData() || {};
  return (
    <React.Fragment>
      <img className='game-rating-image' src={ratingIconUrl} alt={ratingName} />
      <div className='game-rating-text-container'>
        {ratingUrl ? (
          <span
            role='button'
            tabIndex={0}
            onKeyDown={() => {
              modalService.open();
            }}
            onClick={() => {
              modalService.open();
            }}
            className='font-header-2 text-emphasis header-link'>
            {ratingName}
          </span>
        ) : (
          <span className='font-header-2 text-emphasis'>{ratingName}</span>
        )}

        {ratingDescription && (
          <span className='font-caption-body text-muted rating-descriptor'>
            {ratingDescription}
          </span>
        )}
        {interactiveDescription && (
          <span className='font-caption-body text-muted interactive-descriptor'>
            {interactiveDescription}
          </span>
        )}
      </div>
      {ratingUrl && (
        <Modal
          title={translate('Message.LeavingRobloxTitle')}
          body={translate('Message.ExternalLinkWarning')}
          neutralButtonText={translate('Action.Cancel')}
          actionButtonText={translate('Action.Continue')}
          actionButtonShow
          onAction={() => {
            window.open(ratingUrl, '_blank');
            modalService.close();
          }}
        />
      )}
    </React.Fragment>
  );
};

export default withTranslations(Ratings, ratingsTranslationConfig);
